import { render } from "./DialogPurchaseError.vue?vue&type=template&id=bbc1b3e4"
import script from "./DialogPurchaseError.vue?vue&type=script&lang=js"
export * from "./DialogPurchaseError.vue?vue&type=script&lang=js"
script.render = render

export default script